import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CAMPAIGN_SUPPORTER_VOICES_SETTINGS = createFcmDetails('campaign_supporter_voices_settings', {
	owner: 'Campaign Squad',
	context: 'Supporter voices configuration on /p/:slug/actions page',
	description:
		'This creates a configuration file for various features and settings on the /p/:slug/actions page. It holds: \n - maxVideoSize: video upload limit in megabytes \n - maxImageSize: image upload limit in megabytes',
	/*
	 * For new properties, please append the following line to the end of the description string.
	 * \n - <propertyName>: <property value description>
	 */
	import: false,
	template: {
		minVideoSize: 0.04,
		maxVideoSize: 20,
		maxImageSize: 5,
	},
});
